<template>
    <div>
		<!-- end breadcrumb -->
		<!-- begin page-header -->
		<h1 class="page-header">{{title}} Product Plan</h1>
        <hr>

		<p style="color:red;white-space: pre-line">{{errorText}}</p>

        <div style="padding : 0 1%">
            <div>

				<!-- <div class="form-group">
					<label>Date</label>
					<flatpickr
						v-model="data.date"
						:config="rangeConfig"
						placeholder="Range Picker"
						disabled
					/>
				</div> -->
				<div class="form-group">
					<label>Location Code</label>
					<input type="text" class="form-control" disabled v-model='data.loc_code'/>
				</div>

				<div class="form-group">
					<label>Daily</label>
					<input type="number" placeholder="Input Daily Target" class="form-control" v-model='data.daily'/>
				</div>
				<div class="form-group">
					<label>Monthly</label>
					<input type="number" placeholder="Input Monthly Target" class="form-control" v-model='data.monthly'/>
				</div>
				<div class="form-group">
					<label>Status</label>
					<br>
					<toggle-button 
						v-model="data.status"
						:width="100"
						:height="25"
						color="#7dCE94" 
						:sync="true" 
						:labels="{checked: 'ACTIVE', unchecked: 'INACTIVE'}"
					/>
				</div>

				

				<div class="form-group mt-5">
					<div class="row">
						<div class="col-3 offset-6">
							<button class="btn btn-primary w-100 p-5" @click="addPlan" >Submit</button>
						</div>
						<div class="col-3">
							<button class="btn btn-danger w-100 p-5" v-on:click="$emit('closeModal')">Cancel</button>
						</div>
					</div>
					
				</div>
            </div>
        </div>
    </div>
</template>

<script>
import flatpickr from 'vue-flatpickr-component'
// import 'flatpickr/dist/flatpickr.css';
import moment from 'moment'
import { ToggleButton } from 'vue-js-toggle-button'

export default {
	components : {
		flatpickr,
		ToggleButton
	},
	props : ['dataDetail' , 'method', 'title'],
    data(){
        return {
            data : {
				// date : new moment().format("Y-MM-DD HH:mm:ss"),
				loc_code : 'DPDC-PST',
				daily : 0,
				monthly : 0,
				status : true
			},
			rangeConfig: {
				altInput: true,
				altInputClass: 'form-control input form-control-date',
				animate: !isRTL() 
			},
			errorText : ''
        }
	},
	mounted () {
		if(this.dataDetail) {
			this.data = this.dataDetail
			this.data.status = this.data.status == 'ACTIVE' ? true : false
			console.log(this.data)
		}
	},
    methods : {
        async addPlan(){
			let error = await this.validate(this.data)
			console.log(this.data)

			if(error.length > 0) {
				this.errorText = error.join('\n')
				return
			}
			else
				this.errorText = ''

			let url = '/api/product_plan'

			if(this.title != 'Add')
				url += '/' + this.dataDetail.id

			let data = Object.assign({} , this.data)

			data.status = data.status ? 'ACTIVE' : 'INACTIVE'

			this.$http[this.method](url, data)
			.then((resp)=> {
				console.log("Success", resp.data.data)
				this.$emit('updateTable')
				this.$emit('closeModal')
			})
			.catch((err) => {
				console.log(err)
			})

		},
		validate (data) {
			let keys = Object.keys(data)
			let error = []

			for(var i = 0 ; i < keys.length ; i++) {
				if(typeof(data[keys[i]]) == 'boolean')
					continue
				if(data[keys[i]] == '' || data[keys[i]] == null || data[keys[i]] == 0)
					error.push(`${keys[i]} cannot be empty!`)
			}

			return error
		}
    }
}

function isRTL () {
    return document.documentElement.getAttribute('dir') === 'rtl' || document.body.getAttribute('dir') === 'rtl'
}
</script>

<style>
	.form-control-date[readonly] {
		background-color: #e9ecef !important;
		opacity: 1;
	}

</style>


